import { Component } from '@angular/core';

@Component({
  selector: 'cat-page',
  templateUrl: './page-500.html'
})

export class PagesPage500 {}




// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/pages/page-500.page.ts